"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDeploymentImages = void 0;
const releaseDateMs = (d) => (d && d.releaseDate ? d.releaseDate.toMillis() : 0);
const isCustom = (d) => !!(d.user || d.team);
const displayName = (d) => d.snapshotTitle || d.label || '';
// Canonical picker ordering: 1) your custom images first, then 2) newest release
// date, then 3) reverse alphabetical. The first element is what the picker shows at
// the top and what SetupSession defaults to when there's no usable prefill.
const sortDeploymentImages = (images) => {
    return (images || [])
        .slice()
        .sort((a, b) => {
        const aCustom = isCustom(a) ? 0 : 1;
        const bCustom = isCustom(b) ? 0 : 1;
        if (aCustom !== bCustom)
            return aCustom - bCustom;
        const releaseDiff = releaseDateMs(b) - releaseDateMs(a);
        if (releaseDiff !== 0)
            return releaseDiff;
        return displayName(b).localeCompare(displayName(a));
    });
};
exports.sortDeploymentImages = sortDeploymentImages;
